export const ANGULARJS_ROUTE_DATA = {
    CONFIRM_EMAIL: {
        PATH: 'ConfirmEmail/:id',
    },
    LOGOUT: {
        PATH: 'LogOut',
    },
    LANDING: {
        PATH: 'Landing',
    },
};
